import { useSpring, animated } from '@react-spring/web'
import { useSelector } from 'react-redux'
import { selectUrl } from 'hooks/urlInfo'
import { useNavigate } from 'react-router-dom'

const NavigateButtonCps = () => {
	const urlInfo = useSelector(selectUrl)
	const navigate = useNavigate()

	const menuMove1 = useSpring({
		from: { y: 100, opacity: 0 },
		to: { y: 0, opacity: 1 },
		delay: 0,
	})
	const menuMove2 = useSpring({
		from: { y: 100, opacity: 0 },
		to: { y: 0, opacity: 1 },
		delay: 100,
	})

	const moveToHome = () => {
		console.log(urlInfo)
		window.location.href = `${urlInfo}`
	}

	return (
		<ul className="cpsBtnContainer">
			<animated.li style={menuMove1}>
				<button
					type="button"
					className="btnHome"
					onClick={moveToHome}
				/>
			</animated.li>
			<animated.li style={menuMove2}>
				<button
					type="button"
					className="btnBack"
					onClick={() => navigate(-1)}
				/>
			</animated.li>
		</ul>
	)
}

export default NavigateButtonCps
